import { useEffect, useState, useMemo } from 'react';
const getRefPosition = (entry) => {
    if (entry.isIntersecting) {
        return 'shown';
    }
    if (entry.boundingClientRect) {
        const { top, bottom, height } = entry.boundingClientRect;
        if (bottom - height <= 0) {
            return 'above';
        }
        else if (top + height >= window.innerHeight) {
            return 'below';
        }
    }
    return 'shown';
};
export const useIsInViewport = (ref, options) => {
    const [isInViewport, setIsInViewport] = useState(false);
    const [refPosition, setRefPosition] = useState();
    const observer = useMemo(() => {
        if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
            return null;
        }
        return new IntersectionObserver(([entry]) => {
            if (!entry) {
                return;
            }
            setIsInViewport(entry.isIntersecting);
            setRefPosition(getRefPosition(entry));
        }, options);
    }, [options]);
    useEffect(() => {
        if (!observer || !(ref === null || ref === void 0 ? void 0 : ref.current)) {
            return;
        }
        observer.observe(ref.current);
        return () => {
            observer.disconnect();
        };
    }, [ref, observer]);
    return { isInViewport, refPosition };
};
